
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/list",
      function () {
        return require("private-next-pages/product/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/list"])
      });
    }
  